import React, { useCallback, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Header from './assets/components/header/Header';
import Contact from './assets/components/contact/Contact';
import Form from './assets/components/form/Form';
import Footer from './assets/components/footer/Footer';
import HelmetDE from './assets/components/helmet/HelmetDE';
import HelmetEN from './assets/components/helmet/HelmetEN';
import ThankYou from './assets/components/thanks/ThankYou';

function App() {

  const [language, setLanguage] = useState('de');
  const [formSent, setFormSent] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const de = 'de';
  
  const languageHandler = (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  }

  const fetchForm = useCallback(async (body) => {

    const requestOption = {
        method: "POST",
        redirect: "follow",
        'Content-Type': 'application/json',
        body: JSON.stringify(body),
    }

    const url = "https://strefa.indigo-nails.com/api/users/createCandidate";

    try{
        const response = await fetch(url, requestOption);
        if(!response.ok) {
            throw new Error('error');
        }
        const data = await response.json();

        if(data.insertedID > 0) {
          setFormSent(true);
          navigate('/' + i18n.language + '/thank-you');
        }
    } catch(error) {
        alert(error.message);
    }
  }, []);
  
  return (
    <React.Fragment>
      {
      language === 'de' ? 
      <HelmetDE
        onTranslate = { t }
      /> : 
      <HelmetEN 
        onTranslate = { t }
      />
      }
      <Routes>
        <Route path="/:lang/">
          <Route index element={
            <>
            <Header
              onTranslate = { t }
              languageHandler = {languageHandler}
            />
            <Contact
              onTranslate = { t }
            />
            <Form
              onTranslate = { t }
              onSubmitData = {fetchForm}
            />
            <Footer
              onTranslate = { t }
            />
            </>
          }/>
        </Route>
        <Route path="/" element={<Navigate to="/de"/>}/>
        <Route 
          path="/:lang/thank-you" 
          element={formSent ? <ThankYou onTranslate = { t }/> : <Navigate to="/"/>}
        />
      </Routes>
    </React.Fragment>
  );
}

export default App;
